import React from "react";
import { GameStateSchema, HydratedBook } from "./stateMachine/gameStateMachine";
import DraggableBook from "./DraggableBook";
import DroppableCategory from "./DroppableCategory";
import AnswerCategory from "./AnswerCategory";
import { Answer } from "./utils/sortCorrectAndIncorrectAnswers";

export const Game = ({ state, send }: { state: any; send: Function }) => {
  const books = state.context.booksToSelectFrom;
  const categories = state.context.finalizedCategories;
  const userSelections = state.context.userSelections;

  console.log({
    component: "game",
    books,
    categories,
    userSelections,
  });

  const onDropBook = (book: HydratedBook, categoryName: string) => {
    console.log(`Dropped book: ${book.title} into category: ${categoryName}`);
    return send("SELECT", { bookId: book.id, categoryName });
  };

  console.log({
    gameIsOver: state.context.gameIsOver,
    booksCategorizedByOpenAI: state.context.booksCategorizedByOpenAI,
  });
  const { gameIsOver } = state.context;

  const isWaitingRestart = state.value.toString() === "waitingRestart";

  return (
    <>
      <div className="book-covers">
        {books.map((book: HydratedBook) => {
          return <DraggableBook key={book.id} book={book} />;
        })}
        {isWaitingRestart && (
          <button
            onClick={() => send("RESTART")}
            className="bg-blue-500 text-white font-bold py-2 px-4 rounded-md"
          >
            Next Round
          </button>
        )}
        {gameIsOver && (
          <h1 className="text-4xl font-bold text-center mb-4">Game Over</h1>
        )}
      </div>

      <div className="categories">
        {categories.map((category: string, index: number) => {
          return (
            <div className="category" key={category}>
              <p>
                {category} (
                {state.context.booksCategorizedByOpenAI[index].books.length})
              </p>
              {gameIsOver || isWaitingRestart ? (
                <AnswerCategory
                  key={category}
                  index={index}
                  name={state.context.booksCategorizedByOpenAI[index].name}
                  answers={state.context.answers.filter(
                    ({ correctCategory, givenCategory }: Answer) =>
                      correctCategory === index || givenCategory === index
                  )}
                />
              ) : (
                <DroppableCategory
                  key={category}
                  onDropBook={(book: HydratedBook) => {
                    onDropBook(book, category);
                  }}
                  books={userSelections[index]}
                  answers={
                    state.context.gameIsOver
                      ? state.context.booksCategorizedByOpenAI[index]
                      : undefined
                  }
                />
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};
